/* 左侧导航菜单数据 */
const MenuData = [
    { name: '基础设置', id: 0 },
    { name: '地图设置', id: 1 },
    { name: '分类设置', id: 2 },
    { name: '点位设置', id: 3 },
    { name: '弹窗设置', id: 4 },
    { name: '列表设置', id: 5 },
    { name: '路线设置', id: 6 },
    { name: '高级设置', id: 7 }
]

/* 分类样式数据 */
const typeData = [
    { url: 'https://p.ananas.chaoxing.com/star3/origin/41366b02eab51995cd14932390febc98.jpg', id: 1 },
    // { url: 'https://p.ananas.chaoxing.com/star3/origin/41366b02eab51995cd14932390febc98.jpg', id: 2},
    // { url: 'https://p.ananas.chaoxing.com/star3/origin/41366b02eab51995cd14932390febc98.jpg', id: 3}
]

/* 点位样式数据 */
const pointStyle = [
    { url: 'https://p.ananas.chaoxing.com/star3/origin/68c4771cb39a1fd3c943feb784bea15b.jpg', id: 1, name: '显示图片和名称', pic: true, text: true, icon: false },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/a9703f67e9fec191d8320d0ce302e202.jpg', id: 2, name: '仅显示图片', pic: true, text: false, icon: false },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/e78669b554b7f998b5a28e768b5f8088.jpg', id: 3, name: '仅显示图标', pic: false, text: false, icon: true },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/df18de4b289f9c58a16a9d2e12532ef8.jpg', id: 4, name: '仅显示名称', pic: false, text: true, icon: false },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/f244f2a7e1f016068a5d5039825d86af.jpg', id: 5, name: '显示图标和名称', pic: false, text: true, icon: true },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/b9b163c96277f8056700c793ef09cdb8.gif', id: 6, name: '鼠标移入显示名称', pic: true, text: true, icon: false },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/5b74ece1e52335b912ddb796d9aafd13.gif', id: 7, name: '鼠标移入显示图片', pic: true, text: true, icon: true },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/3e9e48c87ccfe0f9f2e95c424f90f379.gif', id: 8, name: '鼠标移入显示图片和名称', pic: true, text: true, icon: true }
]

/* 弹窗样式数据 */
const popStyle = [
    { url: 'https://p.ananas.chaoxing.com/star3/origin/b92b46ad872e9c96563eb4815c89d3ab.jpg', id: 1, score: 0 },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/34505cab3f563cecc17f400bdb59e99f.png', id: 1, score: 1 },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/c6cbea289c1656601a3da2e37e109b7f.png', id: 2, score: 1 },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/90c6dd14c320634399c1946ad4f38fda.png', id: 3, score: 1 },
    // { url: 'https://p.ananas.chaoxing.com/star3/origin/90c6dd14c320634399c1946ad4f38fda.png', id: 4, score: 1}
    // { url: 'https://p.ananas.chaoxing.com/star3/origin/b92b46ad872e9c96563eb4815c89d3ab.jpg', id: 3}
]

/* 列表样式数据 */
const listStyle = [
    { url: 'https://p.ananas.chaoxing.com/star3/origin/9a2fe2277d2802360971e9702f2bb35c.png', id: 1, score: 1 },
    { url: 'https://p.ananas.chaoxing.com/star3/origin/5da2932de2ac5decccf325d7274cef11.png', id: 1, score: 0 }
]

/* 定制页面fid */
const customMap = [
    { fid: '250677', page: 'binzhou' }, // 滨州 
    { fid: '138061', page: 'weinan', formUserId: '1211818131' }, // 渭南
    { fid: '295951', page: 'yuji' }, // 禹迹
    { fid: '166970', page: 'dspc' }, // 东胜
    { fid: '138053', page: 'longyanapp', screen: 'app' }, // 龙岩
    { fid: '26091', page: 'hbckfzdlm' }, // 湖北省高等教育综合服务系统门户（楚课联盟大发展）
    { fid: '332110', page: 'sdopenUniversity' }, // 山东开放大学
    { fid: '331112', page: 'enshizhou' }, // 恩施州非遗地图
    { fid: '328720', page: 'gannan' }, // 客家文化赣南生态保护区
    { fid: '3067', page: 'sxgcmap' }, // 山西工程技术学院
    { fid: '46576', page: 'hebeidaxue' }, //河北大学
    { fid: '855', page: 'fujianshifan' }, //福建省师范大学
    { fid: '253618', page: 'qinduqu' }, // 秦都区文化馆
    { fid: '185879', page: 'hangjinqiapp', screen: 'app' }, // 杭锦旗文化和旅游局
    { fid: '16783', page: 'dalateqiapp', screen: 'app' }, // 达拉特旗图书馆
    { fid: '4624', page: 'xianyangzhiye' }, // 咸阳职业技术学院
    { fid: '2896', page: 'fzsanfangqixiang', formUserId: '5043443130' }, // 福州三坊七巷
    { fid: '341356', page: 'taiyuan', open: true }, // 太原(晋中文化)
    { fid: '344063', page: 'presidentXisuperMap', open: true }, // 习总书记
    { fid: '46482', page: 'huian', open: true }, // 惠安
    { fid: '24859', page: 'mhMap', open: true }, // 山东省教育厅门户地图
]

/* 定制鼠标移入图片交互 222755上海虹口 先定制后通用 */
const customMaphoverImg = [
    { fid: 222755, code: 310109019, image: 'https://p.ananas.chaoxing.com/star3/origin/046b5813c94ef4b88a0ebdb2fff96d1b.png' },
    { fid: 222755, code: 310109010, image: 'https://p.ananas.chaoxing.com/star3/origin/a8ee813252c2ad6bc24631dce44a8d05.png' },
    { fid: 222755, code: 310109009, image: 'https://p.ananas.chaoxing.com/star3/origin/fb676739a120f15d6e066c23cf108e78.png' },
    { fid: 222755, code: 310109014, image: 'https://p.ananas.chaoxing.com/star3/origin/d196524723c70786bd6f26c4923eb799.png' },
    { fid: 222755, code: 310109016, image: 'https://p.ananas.chaoxing.com/star3/origin/d29be5235ce64fed6542c2b1637f37e3.png' },
    { fid: 222755, code: 310109011, image: 'https://p.ananas.chaoxing.com/star3/origin/c3879fd62e47809106d3bf4bb124c996.png' },
    { fid: 222755, code: 310109017, image: 'https://p.ananas.chaoxing.com/star3/origin/e4035ead98afcfa7af3c3aa16f679e4e.png' },
    { fid: 222755, code: 310109, image: 'https://p.ananas.chaoxing.com/star3/origin/8867ee679ffb3dd549363c95f451afce.png' }
]
/* 浙江省  */
const customMaphoverImgZj = [
    { fid: 6501, code: 330500, image: require('@/assets/map/zhejiang/huzhou.png'), city: "湖州市" },  //湖州
    { fid: 6501, code: 330400, image: require('@/assets/map/zhejiang/jiaxing.png'), city: "嘉兴市" }, //嘉兴
    { fid: 6501, code: 330100, image: require('@/assets/map/zhejiang/hangzhou.png'), city: "杭州市" }, //杭州
    { fid: 6501, code: 330600, image: require('@/assets/map/zhejiang/shaoxing.png'), city: "绍兴市" }, //绍兴
    { fid: 6501, code: 330200, image: require('@/assets/map/zhejiang/ningbo.png'), city: "宁波市" }, //宁波
    { fid: 6501, code: 330800, image: require('@/assets/map/zhejiang/quzhou.png'), city: "衢州市" }, //衢州
    { fid: 6501, code: 330700, image: require('@/assets/map/zhejiang/jinhua.png'), city: "金华市" }, //金华
    { fid: 6501, code: 331000, image: require('@/assets/map/zhejiang/taizhou.png'), city: "台州市" }, //台州
    { fid: 6501, code: 331100, image: require('@/assets/map/zhejiang/lishui.png'), city: "丽水市" }, //丽水
    { fid: 6501, code: 330300, image: require('@/assets/map/zhejiang/wenzhou.png'), city: "温州市" }, //温州
    { fid: 6501, code: 330900, image: require('@/assets/map/zhejiang/zhoushan.png'), city: "舟山市" } //舟山
]
/* 定制鼠标移入图片交互 巡课版为橙色 展示链接*/
const customMapHubeihoverImg = [
    // { fid: 26091, code: 420300, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/165054/shiyanshi.png') },
    // { fid: 26091, code: 429021, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/165054/shennongjia.png') },
    // { fid: 26091, code: 420600, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/165054/xiangyang.png') },
    // { fid: 26091, code: 421300, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/165054/suizhoushi.png') },
    { fid: 26091, code: 420300, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/newXunke/shiyanshi.png') },
    { fid: 26091, code: 429021, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/newXunke/shennongjia.png') },
    { fid: 26091, code: 420600, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/newXunke/xiangyangshi.png') },
    { fid: 26091, code: 421300, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/newXunke/suizhoushi.png') },

    { fid: 26091, code: 429005, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newXunke/qianjiangshi.png') },
    { fid: 26091, code: 429006, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newXunke/tianmenshi.png') },
    { fid: 26091, code: 429004, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newXunke/xiantaoshi.png') },
    { fid: 26091, code: 420900, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newXunke/xiaoganshi.png') },
    { fid: 26091, code: 420100, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newXunke/wuhanshi.png') },
    { fid: 26091, code: 420700, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newXunke/ezhoushi.png') },
    { fid: 26091, code: 421200, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newXunke/xianningshi.png') },
    { fid: 26091, code: 420200, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newXunke/huangshishi.png') },
    { fid: 26091, code: 421100, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newXunke/huanggangshi.png') },
    // { fid: 26091, code: 429005, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/qianjiangshi.png') },
    // { fid: 26091, code: 429006, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/tianmenshi.png') },
    // { fid: 26091, code: 429004, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/xiantaoshi.png') },
    // { fid: 26091, code: 420900, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/xiaoganshi.png') },
    // { fid: 26091, code: 420100, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/wuhanshi.png') },
    // { fid: 26091, code: 420700, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/ezhoushi.png') },
    // { fid: 26091, code: 421200, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/xianningshi.png') },
    // { fid: 26091, code: 420200, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/huangshishi.png') },
    // { fid: 26091, code: 421100, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/huanggangshi.png') },
    { fid: 26091, code: 420800, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/newXunke/jingmenshi.png') },
    { fid: 26091, code: 421000, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/newXunke/jingzhoushi.png') },
    { fid: 26091, code: 420500, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/newXunke/yichangshi.png') },
    { fid: 26091, code: 422800, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/newXunke/enshi.png') },

    // { fid: 26091, code: 420800, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/165054/jingmenshi.png') },
    // { fid: 26091, code: 421000, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/165054/jingzhoushi.png') },
    // { fid: 26091, code: 420500, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/165054/yichangshi.png') },
    // { fid: 26091, code: 422800, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/165054/enshi.png') },
    // { fid: 26091, code: 420300, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/shiyanshi.png') },
    // { fid: 26091, code: 429021, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/shennongjia.png') },
    // { fid: 26091, code: 420600, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/xiangyang.png') },
    // { fid: 26091, code: 421300, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/suizhoushi.png') },

    // { fid: 26091, code: 429005, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/qianjiangshi.png') },
    // { fid: 26091, code: 429006, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/tianmenshi.png') },
    // { fid: 26091, code: 429004, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/xiantaoshi.png') },
    // { fid: 26091, code: 420900, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/xiaoganshi.png') },
    // { fid: 26091, code: 420100, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/wuhanshi.png') },
    // { fid: 26091, code: 420700, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/ezhoushi.png') },
    // { fid: 26091, code: 421200, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/xianningshi.png') },
    // { fid: 26091, code: 420200, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/huangshishi.png') },
    // { fid: 26091, code: 421100, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/huanggangshi.png') },


    // { fid: 26091, code: 420800, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/jingmenshi.png') },
    // { fid: 26091, code: 421000, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/jingzhoushi.png') },
    // { fid: 26091, code: 420500, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/yichangshi.png') },
    // { fid: 26091, code: 422800, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/enshi.png') },
]

/* 定制鼠标移入图片交互 交互版为蓝色 展示链接*/
const customMapHubeihoverImgJiaohu = [
    // { fid: 26091, code: 420300, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/165054/shiyanshi.png') },
    // { fid: 26091, code: 429021, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/165054/shennongjia.png') },
    // { fid: 26091, code: 420600, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/165054/xiangyang.png') },
    // { fid: 26091, code: 421300, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/165054/suizhoushi.png') },
    { fid: 26091, code: 420300, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/shiyanshi.png') },
    { fid: 26091, code: 429021, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/shennongjia.png') },
    { fid: 26091, code: 420600, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/xiangyangshi.png') },
    { fid: 26091, code: 421300, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/suizhoushi.png') },

    { fid: 26091, code: 429005, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/qianjiangshi.png') },
    { fid: 26091, code: 429006, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/tianmenshi.png') },
    { fid: 26091, code: 429004, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/xiantaoshi.png') },
    { fid: 26091, code: 420900, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/xiaoganshi.png') },
    { fid: 26091, code: 420100, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/wuhanshi.png') },
    { fid: 26091, code: 420700, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/ezhoushi.png') },
    { fid: 26091, code: 421200, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/xianningshi.png') },
    { fid: 26091, code: 420200, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/huangshishi.png') },
    { fid: 26091, code: 421100, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/huanggangshi.png') },
    // { fid: 26091, code: 429005, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/qianjiangshi.png') },
    // { fid: 26091, code: 429006, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/tianmenshi.png') },
    // { fid: 26091, code: 429004, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/xiantaoshi.png') },
    // { fid: 26091, code: 420900, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/xiaoganshi.png') },
    // { fid: 26091, code: 420100, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/wuhanshi.png') },
    // { fid: 26091, code: 420700, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/ezhoushi.png') },
    // { fid: 26091, code: 421200, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/xianningshi.png') },
    // { fid: 26091, code: 420200, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/huangshishi.png') },
    // { fid: 26091, code: 421100, dxq: '武汉都市圈', city: '', image: require('@/assets/map/165054/huanggangshi.png') },
    { fid: 26091, code: 420800, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/jingmenshi.png') },
    { fid: 26091, code: 421000, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/jingzhoushi.png') },
    { fid: 26091, code: 420500, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/yichangshi.png') },
    { fid: 26091, code: 422800, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/newZhanshi/enshi.png') },

    // { fid: 26091, code: 420800, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/165054/jingmenshi.png') },
    // { fid: 26091, code: 421000, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/165054/jingzhoushi.png') },
    // { fid: 26091, code: 420500, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/165054/yichangshi.png') },
    // { fid: 26091, code: 422800, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/165054/enshi.png') },
]
/* 定制鼠标移入图片交互 交互版为蓝色 展示链接*/
const customMapHubeihoverImgDxqXunke = [
    { fid: 26091, code: 420300, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/dushiquanXunke/wuhandushiquan.png') },
    { fid: 26091, code: 429021, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/dushiquanXunke/xiangyangdushiquan.png') },
    { fid: 26091, code: 420600, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/dushiquanXunke/yijingjidushuquan.png') },

]
const customMapHubeihoverImgDxqJiaohu = [
    { fid: 26091, code: 420300, dxq: '武汉都市圈', city: '', image: require('@/assets/map/26091/dushiquanHudong/wuhandushiquan.png') },
    { fid: 26091, code: 429021, dxq: '襄阳都市圈', city: '', image: require('@/assets/map/26091/dushiquanHudong/xiangyangdushiquan.png') },
    { fid: 26091, code: 420600, dxq: '宜荆荆都市圈', city: '', image: require('@/assets/map/26091/dushiquanHudong/yijingjidushiquan.png') },
]

/* 填充图片样式数据 */
const fillimageData = [
    { id: 1, name: '自然清新', url: 'https://p.ananas.chaoxing.com/star3/origin/2186a20880ab4ae71ec16169d987d7c6.jpg' },
    { id: 2, name: '深色星空', url: 'https://p.ananas.chaoxing.com/star3/origin/f491599fb067d8521446bd6e6465431b.jpg' },
    { id: 3, name: '古风素雅', url: 'https://p.ananas.chaoxing.com/star3/origin/56a71ff3e7bf8654ad5ae247212e3ea7.jpg' }
]

/* 定制鼠标移入图片交互 331112恩施州 先定制后通用 */
const customMapenshizhouhoverImg = [
    { fid: 331112, code: 422801, image: 'https://p.cldisk.com/star3/origin/9101b857d90e0746029dd39e9068b922.png' },
    { fid: 331112, code: 422802, image: 'https://p.cldisk.com/star3/origin/948cab0f416810d2958650d872e7f1d0.png' },
    { fid: 331112, code: 422822, image: 'https://p.cldisk.com/star3/origin/b0d1552e27e5f524feee221a30a81b0d.png' },
    { fid: 331112, code: 422823, image: 'https://p.cldisk.com/star3/origin/2e78785dcd9b95d8e64616bca6461f4f.png' },
    { fid: 331112, code: 422825, image: 'https://p.cldisk.com/star3/origin/258481ebe7fa5095a2834738f29212e0.png' },
    { fid: 331112, code: 422826, image: 'https://p.cldisk.com/star3/origin/9f5cf357d127381b8416d8fb487c65e6.png' },
    { fid: 331112, code: 422827, image: 'https://p.cldisk.com/star3/origin/d10883515d2ed1934fa0506b8ca57597.png' },
    { fid: 331112, code: 422828, image: 'https://p.cldisk.com/star3/origin/0fc1b57f44f5218e949b9a89c2ad03db.png' }
]
// 河北大学，不同城市formUserId对照表
const hbuFormUserId = {
    '保定市': 2810411061,
    "石家庄市": 3582079727,
    "承德市": 3674105510,
    '秦皇岛市': 3673781045,
    "张家口市": 3674646591,
    "唐山市": 3673669106,
    '廊坊市': 3674152395,
    "沧州市": 3674123635,
    "衡水市": 3674618963,
    "邢台市": 3673972955,
    "邯郸市": 3673893765,
    "河北省": 2807124496
}
const cdata = {
    MenuData: MenuData,
    typeData: typeData,
    pointStyle: pointStyle,
    popStyle: popStyle,
    listStyle: listStyle,
    customMap: customMap,
    maphoverimages: customMaphoverImg,
    maphoverimagesHubei: customMapHubeihoverImg,
    maphoverimagesHubeiJiaohu: customMapHubeihoverImgJiaohu,
    mapHubeihoverImgDxqXunke: customMapHubeihoverImgDxqXunke,
    mapHubeihoverImgDxqJiaohu: customMapHubeihoverImgDxqJiaohu,
    fillimageData: fillimageData,
    customMapenshizhouhoverImg: customMapenshizhouhoverImg,
    hbuFormUserId: hbuFormUserId,
    customMaphoverImgZj: customMaphoverImgZj

}

export default cdata